 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Product":"Product","Scheme":"Scheme","Statistics":"Statistics","agencyReport":"agencyReport","b2cSettings":"b2cSettings","agencyCargoReport":"agencyCargoReport","agencyFireReport":"agencyFireReport","agencyMaidReport":"agencyMaidReport","agencyMotorReport":"agencyMotorReport","agencyPAReport":"agencyPAReport","agencyPackageReport":"agencyPackageReport","agencyTravelReport":"agencyTravelReport","agencyfireReport":"agencyfireReport","claimsReport":"claimsReport","cargoQuote":"cargoQuote","fireQuote~maidQuote~motorQuote~packageQuote~travelQuote":"fireQuote~maidQuote~motorQuote~packageQuote~travelQuote","fireQuote":"fireQuote","maidQuote":"maidQuote","motorQuote":"motorQuote","packageQuote":"packageQuote","travelQuote":"travelQuote","BusinessClass":"BusinessClass","claimDetail":"claimDetail","claimEntry":"claimEntry","claimListing":"claimListing","claimPosting":"claimPosting","claimUpdateStatus":"claimUpdateStatus","interSettings":"interSettings","memberSettings":"memberSettings","policy":"policy","promotionManagement":"promotionManagement","quotation~quoteListing~quotePosting~quoteUpdateStatus":"quotation~quoteListing~quotePosting~quoteUpdateStatus","quotation":"quotation","quoteListing":"quoteListing","quotePosting":"quotePosting","quoteUpdateStatus":"quoteUpdateStatus","rateManagement":"rateManagement","textManagement":"textManagement","userProfile":"userProfile","userSettings":"userSettings"}[chunkId]||chunkId) + "." + {"Product":"5d2e9dc6","Scheme":"753134a5","Statistics":"bd794715","agencyReport":"760180f0","b2cSettings":"37c96271","chunk-0a421a10":"44358cb5","chunk-0c71dd01":"5230697f","chunk-1963707c":"92cb7502","chunk-21036631":"a7dd675f","chunk-2524bdd9":"f1d05979","chunk-2828f510":"1119a79e","chunk-2f5476a7":"afb53c97","chunk-2f6a55bc":"ac7b3fbe","chunk-350d9383":"7f0b8993","chunk-36a6172a":"992eed0e","chunk-38059203":"cef39e72","chunk-3e8d04c3":"26547f95","chunk-4170a5bc":"91a76a7a","chunk-5fd814a8":"f9c42736","chunk-e43baf02":"6629e07d","chunk-4fcfc304":"1e5c90ac","agencyCargoReport":"e512583f","agencyFireReport":"e05ae39c","agencyMaidReport":"f9c212c0","agencyMotorReport":"4560148c","agencyPAReport":"87592ebb","agencyPackageReport":"3cb59815","agencyTravelReport":"e56ed625","agencyfireReport":"e2b68cd3","chunk-12cc2da4":"c0e704ee","claimsReport":"81594fdf","chunk-536fa0fc":"d2e01d0d","chunk-53f7f53c":"f60878c1","cargoQuote":"34c53e33","chunk-74aa4816":"10f04ffc","fireQuote~maidQuote~motorQuote~packageQuote~travelQuote":"1eddadf1","fireQuote":"27798f43","maidQuote":"23dee8e5","motorQuote":"e2bb59fb","packageQuote":"59f13946","travelQuote":"4eb30f8e","chunk-57f2cade":"39c01f21","chunk-5ae2fff7":"bdf24157","chunk-69954548":"1e2d8992","chunk-7129d5ae":"7af5c98a","chunk-78d0f9fe":"7293c988","chunk-7b661e25":"7a27593a","chunk-7e0a6313":"354b07af","chunk-85de3468":"9472ea3e","chunk-88ee4d3e":"1ab964f6","chunk-9ae184e4":"54fc6593","chunk-af5b7d4c":"84cbe842","chunk-c64f0b88":"4375a738","chunk-d74c0574":"b38b5a1e","BusinessClass":"ba5e9014","chunk-e853373c":"7fa436ab","chunk-f3dc4a02":"e26d5c8b","claimDetail":"b9d109cd","claimEntry":"2f0341ec","claimListing":"e84b780a","claimPosting":"3f5027b0","claimUpdateStatus":"ff4f46e4","interSettings":"73604698","memberSettings":"e6e5d175","policy":"505dfaf2","promotionManagement":"531852c6","quotation~quoteListing~quotePosting~quoteUpdateStatus":"06e5b3f2","quotation":"4f90f3dc","quoteListing":"305870dd","quotePosting":"accad146","quoteUpdateStatus":"9cc99b75","rateManagement":"402255b2","textManagement":"5d89524d","userProfile":"f8b4e3b6","userSettings":"7e665866"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Product":1,"Scheme":1,"Statistics":1,"agencyReport":1,"b2cSettings":1,"chunk-0a421a10":1,"chunk-0c71dd01":1,"chunk-1963707c":1,"chunk-21036631":1,"chunk-2524bdd9":1,"chunk-2828f510":1,"chunk-2f5476a7":1,"chunk-2f6a55bc":1,"chunk-350d9383":1,"chunk-36a6172a":1,"chunk-38059203":1,"chunk-3e8d04c3":1,"chunk-5fd814a8":1,"chunk-e43baf02":1,"chunk-4fcfc304":1,"agencyCargoReport":1,"agencyFireReport":1,"agencyMaidReport":1,"agencyMotorReport":1,"agencyPAReport":1,"agencyPackageReport":1,"agencyTravelReport":1,"agencyfireReport":1,"chunk-12cc2da4":1,"claimsReport":1,"chunk-536fa0fc":1,"chunk-53f7f53c":1,"cargoQuote":1,"chunk-74aa4816":1,"fireQuote~maidQuote~motorQuote~packageQuote~travelQuote":1,"fireQuote":1,"maidQuote":1,"motorQuote":1,"packageQuote":1,"travelQuote":1,"chunk-57f2cade":1,"chunk-5ae2fff7":1,"chunk-69954548":1,"chunk-7129d5ae":1,"chunk-78d0f9fe":1,"chunk-7b661e25":1,"chunk-7e0a6313":1,"chunk-85de3468":1,"chunk-88ee4d3e":1,"chunk-9ae184e4":1,"chunk-af5b7d4c":1,"chunk-c64f0b88":1,"chunk-d74c0574":1,"BusinessClass":1,"chunk-e853373c":1,"chunk-f3dc4a02":1,"claimDetail":1,"claimEntry":1,"claimListing":1,"claimPosting":1,"claimUpdateStatus":1,"interSettings":1,"memberSettings":1,"policy":1,"promotionManagement":1,"quotation~quoteListing~quotePosting~quoteUpdateStatus":1,"quotation":1,"quoteListing":1,"quotePosting":1,"quoteUpdateStatus":1,"rateManagement":1,"textManagement":1,"userProfile":1,"userSettings":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Product":"Product","Scheme":"Scheme","Statistics":"Statistics","agencyReport":"agencyReport","b2cSettings":"b2cSettings","agencyCargoReport":"agencyCargoReport","agencyFireReport":"agencyFireReport","agencyMaidReport":"agencyMaidReport","agencyMotorReport":"agencyMotorReport","agencyPAReport":"agencyPAReport","agencyPackageReport":"agencyPackageReport","agencyTravelReport":"agencyTravelReport","agencyfireReport":"agencyfireReport","claimsReport":"claimsReport","cargoQuote":"cargoQuote","fireQuote~maidQuote~motorQuote~packageQuote~travelQuote":"fireQuote~maidQuote~motorQuote~packageQuote~travelQuote","fireQuote":"fireQuote","maidQuote":"maidQuote","motorQuote":"motorQuote","packageQuote":"packageQuote","travelQuote":"travelQuote","BusinessClass":"BusinessClass","claimDetail":"claimDetail","claimEntry":"claimEntry","claimListing":"claimListing","claimPosting":"claimPosting","claimUpdateStatus":"claimUpdateStatus","interSettings":"interSettings","memberSettings":"memberSettings","policy":"policy","promotionManagement":"promotionManagement","quotation~quoteListing~quotePosting~quoteUpdateStatus":"quotation~quoteListing~quotePosting~quoteUpdateStatus","quotation":"quotation","quoteListing":"quoteListing","quotePosting":"quotePosting","quoteUpdateStatus":"quoteUpdateStatus","rateManagement":"rateManagement","textManagement":"textManagement","userProfile":"userProfile","userSettings":"userSettings"}[chunkId]||chunkId) + "." + {"Product":"b824937a","Scheme":"ea29db1e","Statistics":"3ea307a6","agencyReport":"eb4d51aa","b2cSettings":"16356c70","chunk-0a421a10":"ac5bf047","chunk-0c71dd01":"b5f60b9a","chunk-1963707c":"2df3e587","chunk-21036631":"f2098bfa","chunk-2524bdd9":"5756f606","chunk-2828f510":"5ffdaf79","chunk-2f5476a7":"8c50ca1b","chunk-2f6a55bc":"0b9e5bb3","chunk-350d9383":"7df6c852","chunk-36a6172a":"6e010cd5","chunk-38059203":"8a86569a","chunk-3e8d04c3":"491e2b43","chunk-4170a5bc":"31d6cfe0","chunk-5fd814a8":"db66fbd5","chunk-e43baf02":"db66fbd5","chunk-4fcfc304":"83c72881","agencyCargoReport":"acc4c229","agencyFireReport":"d5f289ff","agencyMaidReport":"9fca29ea","agencyMotorReport":"27153011","agencyPAReport":"baea0fba","agencyPackageReport":"f5a284cb","agencyTravelReport":"3783792e","agencyfireReport":"129a6d7c","chunk-12cc2da4":"0e433876","claimsReport":"3d193851","chunk-536fa0fc":"6e010cd5","chunk-53f7f53c":"b39a68ef","cargoQuote":"f659d623","chunk-74aa4816":"b30f4e5f","fireQuote~maidQuote~motorQuote~packageQuote~travelQuote":"b9ef0830","fireQuote":"be78a653","maidQuote":"f13d394c","motorQuote":"17c6b791","packageQuote":"f39bfe41","travelQuote":"d11f6745","chunk-57f2cade":"446f379e","chunk-5ae2fff7":"badb5233","chunk-69954548":"0d7e6b99","chunk-7129d5ae":"39f6e2a8","chunk-78d0f9fe":"4ba36f0c","chunk-7b661e25":"4718dfb9","chunk-7e0a6313":"9748892e","chunk-85de3468":"ac5bf047","chunk-88ee4d3e":"769ebb2b","chunk-9ae184e4":"7df6c852","chunk-af5b7d4c":"0b9e5bb3","chunk-c64f0b88":"9476f685","chunk-d74c0574":"58246924","BusinessClass":"b1c71925","chunk-e853373c":"2c10cec3","chunk-f3dc4a02":"6c68b87f","claimDetail":"baba1d64","claimEntry":"24915848","claimListing":"2415ece8","claimPosting":"eca44cb6","claimUpdateStatus":"b0d51ddc","interSettings":"3a51da07","memberSettings":"b467d3a9","policy":"1f11f93b","promotionManagement":"a2450b45","quotation~quoteListing~quotePosting~quoteUpdateStatus":"59312acd","quotation":"e881a1c3","quoteListing":"9616c854","quotePosting":"e5bd4174","quoteUpdateStatus":"84eb0193","rateManagement":"c2a5f3f3","textManagement":"2bf4a761","userProfile":"096e8c60","userSettings":"9761fd37"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var head = document.getElementsByTagName('head')[0];
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
